/**
 * FormInputField Component
 * Reusable form input with consistent styling and built-in label
 *
 * Features:
 * - Consistent label and input styling
 * - Support for various input types
 * - Built-in error state and messaging
 * - Optional helper text
 * - Required field indicator
 * - Disabled state support
 */

import { FORM_GROUP_STYLE, INPUT_STYLE, LABEL_STYLE } from '../../styles/modalStyles';

export interface FormInputFieldProps {
  label: string;
  value: string | number;
  onChange: (value: string) => void;
  type?: 'text' | 'email' | 'number' | 'datetime-local' | 'date' | 'time' | 'tel' | 'password' | 'url';
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  helperText?: string;
  min?: string | number;
  max?: string | number;
  step?: string | number;
  autoComplete?: string;
}

export function FormInputField({
  label,
  value,
  onChange,
  type = 'text',
  placeholder,
  required = false,
  disabled = false,
  error,
  helperText,
  min,
  max,
  step,
  autoComplete,
}: FormInputFieldProps) {
  return (
    <div style={FORM_GROUP_STYLE}>
      <label style={LABEL_STYLE}>
        {label}
        {required && <span style={{ color: '#ef4444', marginLeft: '4px' }}>*</span>}
      </label>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        min={min}
        max={max}
        step={step}
        autoComplete={autoComplete}
        style={{
          ...INPUT_STYLE,
          borderColor: error ? '#ef4444' : '#d1d5db',
          backgroundColor: disabled ? '#f9fafb' : '#ffffff',
          cursor: disabled ? 'not-allowed' : 'text',
        }}
      />
      {error && (
        <span style={{
          display: 'block',
          marginTop: '4px',
          fontSize: '12px',
          color: '#ef4444',
        }}>
          {error}
        </span>
      )}
      {helperText && !error && (
        <span style={{
          display: 'block',
          marginTop: '4px',
          fontSize: '12px',
          color: '#6b7280',
        }}>
          {helperText}
        </span>
      )}
    </div>
  );
}
